import { applyMiddleware, compose, createStore } from 'redux';
// import logger from 'redux-logger';
import thunk from 'redux-thunk';

import rootReducer from './reducers';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = () => {
  const middlewares = [];

  // Optional redux logger
  // if (process.env.NODE_ENV !== "production") {
  //   middlewares.push(logger);
  // }

  // Support making action creators that return functions instead of actions
  middlewares.push(thunk);

  const store = createStore(
    rootReducer,
    // {}, // preloadedState
    composeEnhancers(
      applyMiddleware(...middlewares)
    ),
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}

export default configureStore;
